async function handleQuickAdd(e) {
  const drawerWrapper = document.querySelector(".upsell__sidebar__items")
  const drawerWrapperMobile = document.querySelector("[data-cart-recommended]")

  if (drawerWrapper ) {
    const buttons = drawerWrapper?.querySelectorAll("button") ?? [];

    buttons.forEach((ele)=>{
      ele.style.display = "none"
    })
  }

  if (drawerWrapperMobile) {
    const buttonsMobile = drawerWrapperMobile?.querySelectorAll("button") ?? [];
  
    buttonsMobile.forEach((ele)=>{
      ele.style.display = "none"
      ele.style.opacity = "1"
    })
  }
  
  if (e.classList.contains("is-disabled") || e.classList.contains("has-success")) {
    return;
  }
  // cart upsell
  const loader = document.querySelector("[data-cart-loading]");
  const loadbar = loader.querySelector(".item--loadbar");
  // default
  const wrapper = e.closest("[data-quick-add]");

  var selectedProducts = [];
  var qty =
    wrapper && wrapper.querySelector("[data-quantity-input]")
      ? wrapper.querySelector("[data-quantity-input]").value
      : 1;
  var variantId = parseFloat(e.dataset.addToCartVariant);
  var sellingPlan = e.dataset.sellingPlan ? parseFloat(e.dataset.sellingPlan) : null;
  var quickAddBtns = document.querySelectorAll("[data-open-package-modal]");

  // disabled other package buttons
  if (e.textContent.includes("Select & Join")) {
    quickAddBtns.forEach((btn) => {
      btn.disabled = true;
      e.disabled = false;
    });
  }

  const cart = await getCart();
  // if Kit is already in a cart
  cart.items.forEach((item) => {
    if (item.quantity > 0 && item.id == variantId && item.product_type == "Kit") qty = 0;
  });

  selectedProducts = [
    {
      id: variantId,
      quantity: qty,
      selling_plan: sellingPlan,
      properties: {
        _t: Date.now(),
      },
    },
  ];

  var formData = {
    items: selectedProducts,
  };

  if (selectedProducts.length > 0) {
    e.classList.add("loading");
    e.classList.add("is-disabled");
    if (loader) {
      loadbar.style.display = "block";
      loader.classList.add("cart--loading");
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then(async (response) => {
        await ensureAdminFeeInCart();

        e.classList.remove("loading");
        e.classList.remove("is-disabled");
        e.classList.add("has-success");

        setTimeout(() => {
          e.classList.remove("has-success");
          reloadCart(response.data);
          openDrawer();
          if (loader) {
            loadbar.style.display = "none";
            loader.classList.remove("cart--loading");
          }
        }, 1500);
      })
      .catch((err) => {
        console.error(err);
      });
  }
}

function reloadCart(data) {
  localStorage.setItem("handlequickAdd", true);

  document.dispatchEvent(
    new CustomEvent("theme:cart:change", {
      detail: {
        cart: data,
      },
      bubbles: true,
    }),
  );
  /*
  document.dispatchEvent(
    new CustomEvent("theme:cart:init", {
      bubbles: true,
    })
  );*/
  document.dispatchEvent(
    new CustomEvent("theme:cart:reload", {
      detail: {
        cart: data,
      },
      bubbles: true,
    })
  );

  localStorage.setItem("handlequickAdd", false);
}

function openDrawer() {
  const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
  const modal = document.querySelector("[data-product-modal-container]");

  if (!cartDrawer.classList.contains("drawer--visible") && !modal.classList.contains("is-visible")) {
    cartDrawer.dispatchEvent(
      new CustomEvent("theme:drawer:open", {
        bubbles: true,
      })
    );
  }
}

async function getCart() {
  const result = await fetch("/cart.json");
  if (result.status === 200) return result.json();
  throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}
